import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../actions/globalAction';
import { StatCard } from '../components/solar/StatCard';
import { ChartCardWithPagination } from '../components/solar/ChartCardWithPagination';
import { getOptions } from '../components/options/leistung';
import { data } from '../components/data/leistung';
import { leistung } from '../components/objects/leistung';
import { Line } from 'react-chartjs-2';
import { Card } from 'react-bootstrap';

class MonatsLeistungClass extends Component {
    static getDerivedStateFromProps(nextProps, prevState) {
        const nextYear = parseInt(nextProps.match.params.Year) || 0;
        const nextMonth = parseInt(nextProps.match.params.Month) || 0;
        if (prevState.prevYear !== nextYear || prevState.prevMonth !== nextMonth) {
            return { prevYear: nextYear, prevMonth: nextMonth, _fetchNeeded: true };
        }
        return null;
    }

    componentDidMount() {
        const Year = parseInt(this.props.match.params.Year) || 0;
        const Month = parseInt(this.props.match.params.Month) || 0;

        this.setState({ prevYear: Year, prevMonth: Month }, () => {
            if (Month > 0) {
                leistung.LineDiagrammMonatsleistungClass.forceRefresh = true;
                leistung.LineDiagrammMonatsleistungClass.url = leistung.LineDiagrammMonatsleistungClass.defaultSegment + "/Line/" + Year + "/" + Month;
            }

            for (var k in leistung) {
                this.props.request(leistung[k]);
            }
        });
    }

    componentDidUpdate() {
        if (this.state._fetchNeeded) {
            const nextYear = parseInt(this.props.match.params.Year) || 0;
            const nextMonth = parseInt(this.props.match.params.Month) || 0;

            this.setState({ _fetchNeeded: false }, () => {
                if (nextMonth > 0) {
                    leistung.LineDiagrammMonatsleistungClass.forceRefresh = true;
                    leistung.LineDiagrammMonatsleistungClass.url = leistung.LineDiagrammMonatsleistungClass.defaultSegment + "/Line/" + nextYear + "/" + nextMonth;
                }

                for (var k in leistung) {
                    this.props.request(leistung[k]);
                }
            });
        }
    }

    state = {};

    render() {
        return (
            <div>
                {renderUIKPIRow(this.props)}
                {renderUIGesamt(this.props)}
            </div>
        );
    }
}

const MONATE = ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'];

function computeKpi(data) {
    const max  = Math.max(...data);
    const min  = Math.min(...data);
    const sum  = data.reduce((a, b) => a + b, 0);
    const avg  = sum / data.length;
    return { max, min, sum, avg };
}

function renderUIKPIRow(props) {
    let LineDiagrammMonatsLeistungUI = props.LineDiagrammMonatsLeistungUI || {};

    // BOTH isLoaded=true UND Daten vorhanden — nicht nur auf die Flag verlassen!
    let hasData = Array.isArray(LineDiagrammMonatsLeistungUI.Datum) && LineDiagrammMonatsLeistungUI.Datum.length > 0;
    let loading = !props.isLoaded || !hasData;

    const monthName = MONATE[parseInt(props.match.params.Month) - 1] || '';
    const year = props.match.params.Year || '';

    // KPI-Berechnungen (nur wenn Daten wirklich da sind)
    let maxVal = 0;
    let minVal = 0;
    let avgVal = 0;
    let sumVal = 0;

    if (hasData && Array.isArray(LineDiagrammMonatsLeistungUI.Tagesertrag)) {
        const stats = computeKpi(LineDiagrammMonatsLeistungUI.Tagesertrag);
        maxVal = Math.round(stats.max);
        minVal = Math.round(stats.min);
        avgVal = Math.round(stats.avg);
        sumVal = stats.sum;
    }

    return (
        <div className="row mb-3">
            <div className="col-12">
                <h5>Höchste Monatliche Leistungen — {monthName} {year}</h5>
            </div>
            <div className="col-6 col-md-3">
                <StatCard label={`Max · ${monthName}`} value={maxVal} unit="W" isLoading={loading}
                    description="Höchste gemessene solare Tagesleistung in diesem Monat in Watt." />
            </div>
            <div className="col-6 col-md-3">
                <StatCard label="Min" value={minVal} unit="W" isLoading={loading}
                    description="Niedrigste gemessene solare Tagesleistung in diesem Monat." />
            </div>
            <div className="col-6 col-md-3">
                <StatCard label="Durchschnitt" value={avgVal} unit="W" isLoading={loading}
                    description="Mittlere Leistung aller Tage in diesem Monat." />
            </div>
            <div className="col-6 col-md-3">
                <StatCard label="Summe" value={sumVal.toLocaleString('de-DE')} unit="W" isLoading={loading}
                    description="Summe der täglichen Höchstleistungen. Dient als grober Monatsvergleich." />
            </div>
        </div>
    );
}

function renderUIGesamt(props) {
    let LineDiagrammMonatsLeistungUI = props.LineDiagrammMonatsLeistungUI || {};

    // Loading: BOTH isLoaded=true UND Daten vorhanden. Nicht nur auf die Flag verlassen!
    let hasData = Array.isArray(LineDiagrammMonatsLeistungUI.Datum) && LineDiagrammMonatsLeistungUI.Datum.length > 0;
    let loading = !props.isLoaded || !hasData;

    // default chart data to avoid rendering undefined
    let chartData = { labels: [''], datasets: [{ data: [0] }] };

    if (hasData) {
        const tagesertrag = LineDiagrammMonatsLeistungUI.Tagesertrag;
        chartData = {
            labels: LineDiagrammMonatsLeistungUI.Datum,
            datasets: [
                { ...data.datasets[0], data: tagesertrag }
            ]
        };
    }

    return (
        <ChartCardWithPagination
            routeSegment={'leistung'}
            onlyYear={false}
            match={props.match}
            history={props.history}
            loading={loading}>
            <Card className="chart-card">
                <Card.Body>
                    <Line data={chartData} options={{ ...getOptions(), animation: false }} />
                </Card.Body>
            </Card>
        </ChartCardWithPagination>
    );
}

export default connect(
    state => state.leistungReducer,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(MonatsLeistungClass);
